/**
* this displays the fund actions
*
* Created by Paul on 27/05/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// action import
import { ActionCreator } from '../../actions/'

// Configurations
import constants from '../../constants'

import NumberFormat from 'react-number-format'

// material-ui import
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Badge from '@material-ui/core/Badge'
import { withStyles, makeStyles } from '@material-ui/styles'
import Typography from '@material-ui/core/Typography'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Done from '@material-ui/icons/Done'


const styles = theme => ({
    heading: {
        fontSize: 16,
        flexBasis: '33.33%',
        flexShrink: 0,
        fontWeight: 500,
    },
    gridroot: {
        flexGrow: 1,
    },
    card: {
        height: '100%',
    },
    title: {
        fontSize: 16,
    },
    pos: {
        marginBottom: 12,
    },
    card_body: {
        fontSize: 13,
    },
    list_root: {
        width: '100%',
    },
    list_paper: {
        width: '100%',
        overflowX: 'auto',
        boxShadow: 'none',
    },
    list_table: {
        /*minWidth: 450,*/
    },
    icon: {
        marginTop: -4,
        marginLeft: 0,
        fontSize: 21,
    },
    table_header_cell: {
        fontWeight: 500,
        fontSize: 12,
        paddingLeft: 1,
        '&:last-child': {
            paddingRight: 1,
        },
        color: 'rgba(0, 0, 0, 0.7)',
    },
    table_cell: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 1,
        '&:last-child': {
            paddingRight: 1,
        },
        color: 'rgba(0, 0, 0, 0.7)',
    },
})

class Actions extends Component {

    constructor(props) {
        super(props)

        // Bind the functions
        this.requestBusinessEvents = this.requestBusinessEvents.bind(this)
        this.requestCorporateActions = this.requestCorporateActions.bind(this)

        this.state = {
            businessEventsRequested: false,
            corporateActionsRequested: false
        }
    }

    componentDidMount() {
        const { getFundCashReconciliation, member_id } = this.props
        getFundCashReconciliation(member_id)
    }

    requestBusinessEvents() {
        const { requestBusinessEvents, fundSummary } = this.props
        this.setState({ businessEventsRequested: true })
        requestBusinessEvents(fundSummary.fund_code)
    }

    requestCorporateActions() {
        const { requestCorporateActions, fundSummary } = this.props
        this.setState({ corporateActionsRequested: true })
        requestCorporateActions(fundSummary.fund_code)
    }

    renderCashEvents() {
        const { classes, isFundCashReconciliationLoading, fundCashReconciliationData, fundSummary } = this.props
        
        return (
            <Grid item xs={12}>
                <Card className={classes.card}>
                    <CardContent>

                        <Typography className={classes.title} variant="h5" component="h2">
                            { fundSummary.unmatched_cash_events } Cash Events
                        </Typography>

                        <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                            Outstanding Unmatched Cash Events
                        </Typography>

                        <div className={classes.list_root}>
                            <Paper className={classes.list_paper}>
                                <Table className={classes.list_table} size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={ classes.table_header_cell }>Date</TableCell>
                                            <TableCell className={ classes.table_header_cell }>Description</TableCell>
                                            <TableCell className={ classes.table_header_cell }>Direction</TableCell>
                                            <TableCell className={ classes.table_header_cell } align="right">Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        { fundCashReconciliationData.map((row, index) => (
                                            <TableRow hover key={ index }>
                                                <TableCell className={ classes.table_cell } scope="row">
                                                { row.date }
                                                </TableCell>
                                                <TableCell className={ classes.table_cell }>{ row.description }</TableCell>
                                                <TableCell className={ classes.table_cell }>{ row.debitCreditIndicator }</TableCell>
                                                <TableCell className={ classes.table_cell } align="right"><NumberFormat value={ row.amount } displayType={'text'} thousandSeparator={true} prefix={'$'} /></TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Paper>
                        </div>

                    </CardContent>
                </Card>
            </Grid>
        )
    }

    renderBusinessEvents() {

        const { classes, fundSummary } = this.props

        return (
            <Grid item xs={12} md={4}>
                <Card className={classes.card}>
                    <CardContent>
                        <Typography className={classes.title} variant="h5" component="h2">
                            { fundSummary.unmatched_business_events } Business Events
                        </Typography>

                        <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                            Outstanding business events must be aquired by Selfmade
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button disabled={ this.state.businessEventsRequested } size="small" onClick={() => this.requestBusinessEvents()}>Request Business Events</Button>
                        { this.state.businessEventsRequested && <Done color="action" className={ classes.icon } /> }
                    </CardActions>
                </Card>
            </Grid>
        )
    }

    renderCorporateActions() {

        const { classes, fundSummary } = this.props

        return (
            <Grid item xs={12} md={4}>
                <Card className={classes.card}>
                    <CardContent>
                        <Typography className={classes.title} variant="h5" component="h2">
                            { fundSummary.outstanding_corporate_action_count } Corporate Actions
                        </Typography>

                        <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                            Outstanding Corporate Actions must be aquired by Selfmade
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button disabled={ this.state.corporateActionsRequested } size="small" onClick={() => this.requestCorporateActions()}>Request Corporate Actions</Button>
                        { this.state.corporateActionsRequested && <Done color="action" className={ classes.icon } /> }
                    </CardActions>
                </Card>
            </Grid>
        )
    }

    render() {

        const { classes, fundSummary } = this.props

        return (

            <ExpansionPanelDetails>
                <div className={classes.gridroot}>
                    <Grid container spacing={3}>

                        { fundSummary.unmatched_cash_events > 0 &&
                            this.renderCashEvents()
                        }

                        { fundSummary.unmatched_business_events > 0 &&
                            this.renderBusinessEvents()
                        }

                        { fundSummary.outstanding_corporate_action_count > 0 &&
                            this.renderCorporateActions()
                        }

                        { fundSummary.unmatched_business_events === 0 && fundSummary.outstanding_corporate_action_count === 0 && fundSummary.unmatched_cash_events === 0 &&
                            <Grid item xs={12}>
                                <Typography>No outstanding events or corporate actions</Typography>
                            </Grid>
                        }

                    </Grid>
                </div>
            
            </ExpansionPanelDetails>
        )
    }
}

// define the prop types
Actions.propTypes = {
    classes: PropTypes.object.isRequired,
    isFundCashReconciliationLoading: PropTypes.bool,
    fundCashReconciliationData: PropTypes.array
}

const mapStateToPros = (state) => {
    return {
        isFundCashReconciliationLoading: state.fundState.isFundCashReconciliationLoading,
        fundCashReconciliationData: state.fundState.fundCashReconciliationData,
        fundSummary: state.fundState.fundSummary,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getFundCashReconciliation: action.getFundCashReconciliation,
        requestBusinessEvents: action.requestBusinessEvents,
        requestCorporateActions: action.requestCorporateActions,
    }
}

export default connect(mapStateToPros,mapDispatchToProps)(withStyles(styles)(Actions))


// WEBPACK FOOTER //
// ./src/components/FundActions/index.js